<template>
    <div id="psp_select_modal" class="modal fade" role="dialog">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-body" id="select_psp_modal_body">
                    <form @submit.prevent="savePsp" id="change_psp_form">
                        <p>
                            {{ $t('message.set_psp') }}
                        </p>
                        <kt-form-group>
                            <kt-form-label>
                                {{ $t('label.set_psp') }}
                            </kt-form-label>
                            <kt-form-select size="3" id="set_psp" name="set_psp" v-model="dedicated.psp">
                                <option
                                        v-bind:key="index"
                                        v-for="(psp, index) in psp_list"
                                        v-bind:value="psp.value"
                                        :selected="psp.value"
                                >
                                    {{ psp.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                        <kt-form-action class="mt-4">
                            <button
                                    class="btn btn-md btn-success btn-wide"
                                    type="submit"
                                    id="save_psp"
                            >
                                {{ $t('btn.save') }}
                            </button>
                        </kt-form-action>
                        <input type="hidden" data-dismiss="modal" aria-label="Close" id="hidden_dismiss">
                    </form>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { i18n } from '@/plugins/i18n'
import { dedicatedService } from '@/common/api.service'
import { KTApp } from '@/plugins/core/app'

export default {
    props: {
        dedicated: {
            required: true,
        },
    },
    mounted() {
        $('#psp_select_modal').modal('show');
    },
    data() {
        return {
            psp_list: [
                {
                    name: i18n.t('psp_list.novin'),
                    value: 'novin'
                },
                {
                    name: i18n.t('psp_list.mellat'),
                    value: 'mellat'
                },
                {
                    name: i18n.t('psp_list.saman'),
                    value: 'saman'
                },
                {
                    name: i18n.t('psp_list.pasargad'),
                    value: 'pasargad'
                },
                {
                    name: i18n.t('psp_list.parsian'),
                    value: 'parsian'
                },
                {
                  name: i18n.t('psp_list.sepehr'),
                  value: 'sepehr'
                },
            ],
        }
    },
    methods: {
        savePsp(){
            let form = $('#change_psp_form')
            let btn = $('#save_psp')

            form.validate({
                rules: {
                    set_psp: {
                        required: true,
                    },
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            dedicatedService.setPSP(this.dedicated.id, {'psp': this.dedicated.psp}).then(response => {
                $('#hidden_dismiss').click()
            })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTApp.unprogress(btn)
                })
        },
    }
}
</script>

<style>
</style>